import { Params } from '@angular/router';

/** One thing an admin can do to a table row: a link, or a function to run. */
export interface RowAction {
  label: string;
  /** Material Symbols name, shown in the menu. */
  icon?: string;
  run?: () => unknown;
  link?: unknown[];
  queryParams?: Params;
  /** Destructive: listed last, in red. */
  danger?: boolean;
  hidden?: boolean;
}

/** The first visible action becomes the row's button; the rest go in the menu, destructive ones last. */
export function splitRowActions(actions: RowAction[]): { primary?: RowAction; menu: RowAction[] } {
  const [primary, ...rest] = actions.filter((a) => !a.hidden);
  return { primary, menu: [...rest.filter((a) => !a.danger), ...rest.filter((a) => a.danger)] };
}

/** The "Logs" link the list pages share: this record's UPDATE log entries. */
export function logsAction(subjectType: string, subjectId: number | string | undefined): RowAction {
  return {
    label: 'Logs',
    icon: 'history',
    link: ['', 'log'],
    queryParams: { loglevel: 'UPDATE', subjecttype: subjectType, subjectid: subjectId },
  };
}
